import { useEffect, useState } from "react";
import API from "../Api/Api";

const useApproPackings = (id) => {
  const [loading, setLoading] = useState(false);
  const [packings, setPackings] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);

  const fetchNextPage = async () => {
    setLoading(true);
    try {
      const { data } = await API.get(`/api/approvisionnements/${id}/packings`, {
        params: {
          pagination: {
            page: page + 1,
          },
        },
      });
      setPackings((prev) => [...prev, ...data?.data]);
      const { page: currentPage, pageCount } = data?.meta?.pagination ?? {};
      setHasMore(currentPage < pageCount);
      setPage((page) => page + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async function () {
      setLoading(true);
      try {
        const { data } = await API.get(
          `/api/approvisionnements/${id}/packings`,
          {
            params: {
              pagination: {
                page: 1,
              },
            },
          },
        );
        setPackings(data?.data);
        const { page: currentPage, pageCount } = data?.meta?.pagination ?? {};
        setHasMore(currentPage < pageCount);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);
  return {
    packings,
    fetchNextPage,
    loading,
    hasMore,
  };
};

export default useApproPackings;
